// Full-screen native-only takeover (backlog MOBILE-16) — rendered by
// App.tsx in place of every route (even /login) when the running build is
// below app_version_config's min_required_version for this platform. Not
// dismissible, deliberately: this is the hard-floor case, distinct from
// app-shell.tsx's dismissible "update recommended" banner for everything
// above the floor but below latest_version.
import { Capacitor } from "@capacitor/core";

import { BrandMark } from "@/components/snapdraw/brand";
import { useT } from "@/lib/i18n";

// TODO(MOBILE-16): real store listing URLs, once each is actually live —
// neither store submission had happened as of this feature shipping
// (confirmed via docs/backlog.yaml's MOBILE-3/MOBILE-10 notes). Update
// these the same day either listing goes live; until then the button
// below is hidden rather than link to a URL that doesn't resolve yet.
const STORE_URLS: Partial<Record<"ios" | "android", string>> = {};

export function UpdateRequiredPage({ message }: { message: string | null }) {
  const t = useT();
  const platform = Capacitor.getPlatform();
  const storeUrl = platform === "ios" || platform === "android" ? STORE_URLS[platform] : undefined;

  return (
    <div className="sd-preview blueprint-field flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
      <BrandMark size={72} />
      <div className="max-w-sm space-y-3">
        <h1 className="font-display text-2xl uppercase tracking-wide">{t("update.required.title")}</h1>
        <p className="text-sm text-muted-foreground">{message || t("update.required.body")}</p>
      </div>
      {storeUrl ? (
        <a
          href={storeUrl}
          className="rounded-lg bg-arc px-6 py-3 text-sm font-semibold uppercase tracking-wide text-background"
        >
          {t("update.required.cta")}
        </a>
      ) : (
        <p className="sd-label text-muted-foreground">{t("update.required.storeHint")}</p>
      )}
    </div>
  );
}
